import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectStudentOnboarding = createSelector(
  [(state: AppState) => state.shared.studentOnboarding],
  studentOnboarding => studentOnboarding,
);
